
import { defineComponent } from 'vue'
import IdfAccordion from './IdfAccordion/IdfAccordion.vue'

export default defineComponent({
  name: 'FsAccordion',
  props: {
    title: {
      type: String,
      required: true,
    },
    number: {
      type: Number,
      default: () => null,
    },
  },
  components: { IdfAccordion },
})
